module.exports = __webpack_public_path__ + "static/media/logoAltee.019453c1.svg";